import React from 'react';
import Service from '../components/Service';
import SEO from '../components/SEO';

export default ({ data }) => (
  <div>
    <SEO siteData={data.page.siteData} isSEO />
    <Service data={data.page} image1={data[data.page.image1].sizes} image2={data[data.page.image2].sizes} />
  </div>
);

export const query = graphql`
  query ServicePage($slug: String!) {
    page: servicesDataJson(slug: { eq: $slug }) {
      fields {
        slug
      }
      name
      content1
      content2
      image1
      image2
      list
      link {
        url
        title
      }
      phoneNumbers {
        name
        number
      }
      siteData {
        title
        slug
        description
      }
    }

    service_1: imageSharp(id: { regex: "/service_1.jpg/" }) {
      sizes(maxWidth: 400, maxHeight: 260) {
        ...GatsbyImageSharpSizes_tracedSVG
      }
    }
    service_22: imageSharp(id: { regex: "/service_22.jpg/" }) {
      sizes(maxWidth: 400, maxHeight: 260) {
        ...GatsbyImageSharpSizes_tracedSVG
      }
    }
    service_3: imageSharp(id: { regex: "/service_3.jpg/" }) {
      sizes(maxWidth: 400) {
        ...GatsbyImageSharpSizes
      }
    }
    service_4: imageSharp(id: { regex: "/service_4.jpg/" }) {
      sizes(maxWidth: 400) {
        ...GatsbyImageSharpSizes
      }
    }
    service_5: imageSharp(id: { regex: "/service_5.jpg/" }) {
      sizes(maxWidth: 400) {
        ...GatsbyImageSharpSizes
      }
    }
    service_6: imageSharp(id: { regex: "/service_6.jpg/" }) {
      sizes(maxWidth: 400) {
        ...GatsbyImageSharpSizes
      }
    }
    service_7: imageSharp(id: { regex: "/service_7.jpg/" }) {
      sizes(maxWidth: 400) {
        ...GatsbyImageSharpSizes
      }
    }
    service_8: imageSharp(id: { regex: "/service_8.jpg/" }) {
      sizes(maxWidth: 400) {
        ...GatsbyImageSharpSizes
      }
    }
    service_9: imageSharp(id: { regex: "/service_9.jpg/" }) {
      sizes(maxWidth: 400) {
        ...GatsbyImageSharpSizes
      }
    }
    service_10: imageSharp(id: { regex: "/service_10.jpg/" }) {
      sizes(maxWidth: 400) {
        ...GatsbyImageSharpSizes
      }
    }
    service_11: imageSharp(id: { regex: "/service_11.jpg/" }) {
      sizes(maxWidth: 400) {
        ...GatsbyImageSharpSizes
      }
    }
    service_12: imageSharp(id: { regex: "/service_12.jpg/" }) {
      sizes(maxWidth: 400, maxHeight: 266) {
        ...GatsbyImageSharpSizes
      }
    }
    service_13: imageSharp(id: { regex: "/service_13/" }) {
      sizes(maxWidth: 400) {
        ...GatsbyImageSharpSizes
      }
    }
    service_14: imageSharp(id: { regex: "/service_14/" }) {
      sizes(maxWidth: 400) {
        ...GatsbyImageSharpSizes
      }
    }
  }
`;



// WEBPACK FOOTER //
// ./src/template/services.js